module.exports = __webpack_public_path__ + "prod/1.42.2/img/cycle-seven.4f329cb4.png";